module.exports = __webpack_public_path__ + "img/hr-V-R-3-unload-connect.6e634c39.png";